import React, { FC } from 'react';
import classes from './Select.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

type SelectProps = React.DetailedHTMLProps<React.SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement>

export const Select: FC<SelectProps> = ({ children, ...rest }) => {
    return (
        <div className={classes.wrapper}>
            <FontAwesomeIcon className={classes.icon} icon={faChevronDown}/>
            <select className={classes.root} {...rest}>
                {children}
            </select>
        </div>
    );
};
